import React, { useEffect } from "react";
import ReactDOM from "react-dom";
import Button from "../../../../server/public/shared/ui/inputs/classicButton.js";
import "./submitAction.css";
import { useAutoAnimate } from "@formkit/auto-animate/react";
const container = document.querySelector("#prompt-container");
export default function SubmitAction(props) {
    const { isSaveAction = false } = props;
    useEffect(() => {
        container.classList.add("visible");
        return () => {
            container.classList.remove("visible");
        };
    }, []);
    const [ref] = useAutoAnimate();
    return ReactDOM.createPortal(React.createElement("div", { ref: ref, className: "prompt-box disable-popup-close" },
        props.message,
        props.removeExtraPadding === undefined && React.createElement("br", null),
        React.createElement("div", { className: "alert-buttons-menu-container" },
            !props.withoutCancelButton && (React.createElement(Button, { value: "cancel", text: "Anuluj", version: "alternative", onClick: props.onReject })),
            !props.withoutSubmitButton && (React.createElement(Button, { value: "process", text: isSaveAction ? "Zapisz" : "Wykonaj", version: "classic", onClick: props.onSubmit })))), container);
}
